export default {
  setPayCode: (state, payload) => (state.payCode = payload)
}
